import React, { useState, useEffect } from "react";
import { Link, useNavigate } from 'react-router-dom';
import './../../styles/default/Footer.css';
import Logo from './../../components/logo.png'
import * as globals from './../../components/GlobalScripts.js';

const Footer = () => {
    useEffect(() => {

    }, []);

    return (
        <>
            <footer>
                <p>
                    © 2025 Don Honesto. Todos los derechos reservados, desarrollado por <Link to="https://zadrig.com/">Zadrig</Link>
                </p>
                <div className="container-links">
                    <div>
                        <Link to="/terminos-condiciones">Terminos y condiciones</Link>
                    </div>
                    <div>
                        <Link to="/quiero-trabajar">Quiero trabajar</Link>
                        <Link to="/quiero-contratar">Quiero contratar</Link>
                    </div>
                </div>
            </footer>
        </>
    );
};

export default Footer;